// Buy and cart-recalculate forms are plain AJAX forms. The server checks stock/packing inside the submit
// and, when the customer has to agree first, answers payload.buyConfirm without touching the cart;
// on OK the same form is sent again with confirmed=1.
naja.registerExtension({
    initialize: function(naja) {
        naja.uiHandler.addEventListener('interaction', function(event) {
            var element = event.detail.element;
            var form = element.form || element;
            if (form.elements && form.elements.namedItem('confirmed')) {
                event.detail.options.buyForm = form;
            }
        });
        naja.addEventListener('success', function(event) {
            var payload = event.detail.payload;
            var form = event.detail.options.buyForm;
            if (!payload || !payload.buyConfirm || !form) {
                return;
            }
            // After 'complete' of this request: a new one started earlier would abort it (Naja unique requests)
            setTimeout(function () {
                if (!window.confirm(payload.buyConfirm)) {
                    return;
                }
                var confirmed = form.elements.namedItem('confirmed');
                confirmed.value = 1;
                // submitForm() reads the form data synchronously, so the flag is reset right away
                // (the buy form is not redrawn after the add and would keep confirmed=1)
                naja.uiHandler.submitForm(form);
                confirmed.value = 0;
            }, 0);
        });
    }
});
